import { useState } from 'react'
import { ResponseVariant } from 'workflow/Insights/Insights'

import MainContent from 'features/unifiedFlow/components/MainContent'
import useTweakSuccess from 'features/unifiedFlow/contentPage/hooks/useTweakSuccess'
import useVariantTweakWebsocketSubscription from 'features/unifiedFlow/contentPage/hooks/useVariantTweakWebsocketSubscription'

import { VariantLanguageContextProvider } from '../review/context/VariantLanguageContext'
import useElementState from '../review/hooks/useElementState'
import LeftSection from '../review/leftSection'
import RightSection from '../review/rightSection'

import ManageTableWithFilters from './components/ManageTableWithFilters'
import { VariantStatus } from './utils/variantUtils'

const Manage = () => {
  const [selectedPersonalizationId, setSelectedPersonalizationId] =
    useState<string | undefined>()
  const [variant, setVariant] = useState<ResponseVariant | undefined>()
  const [statusFilter, setStatusFilter] = useState<VariantStatus>('pending')
  useElementState()

  // Websocket subscription for tweak/reject operations
  const { tweakSuccessVariantIds, onTweakSuccess } = useTweakSuccess()

  useVariantTweakWebsocketSubscription({
    onTweakSuccess,
  })

  return (
    <VariantLanguageContextProvider>
      <MainContent className="flex-wrap" id="main-content-page">
        <LeftSection
          onSelectPersonalization={setSelectedPersonalizationId}
          selectedPersonalizationId={selectedPersonalizationId}
          statusFilter={statusFilter}
        />
        <div className="relative flex flex-1">
          <ManageTableWithFilters
            onSelectVariant={setVariant}
            tweakSuccessVariantIds={tweakSuccessVariantIds}
            selectedPersonalizationId={selectedPersonalizationId}
            onStatusFilterChange={setStatusFilter}
          />
          <RightSection selectedVariant={variant} />
        </div>
      </MainContent>
    </VariantLanguageContextProvider>
  )
}

export default Manage
